import React, { useState, useEffect } from "react";

import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import back from "../../assets/svg/backArrow.svg";
import waterBottle from "../../assets/svg/waterBottle.svg";
import "../common/Util.css";
import Dropdown from "react-bootstrap/Dropdown";
import dropDown from "../../assets/svg/dropDown.svg";
import edit from "../../assets/svg/edit.svg";
import threeDots from "../../assets/svg/threedots.svg";
import india from "../../assets/svg/India.svg";
import iButton from "../../assets/svg/iButton.svg";
import locationIc from "../../assets/svg/location.svg";
import logo1 from "../../assets/svg/poUserLogo.svg";
import logo2 from "../../assets/svg/supplierLogo2.svg";
import logo3 from "../../assets/svg/supplierLogo3.svg";
import {
  deleteProductApi,
  getProductDetailsApi,
  updateStatusApi,
} from "./productApi";
import profileIc from "../../assets/png/profile-ic.png";
import { useLocation, useNavigate } from "react-router-dom";
import productDefault from "../../assets/png/product_default.png";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { Toast, ToastContainer } from "react-bootstrap";
import LoaderModal from "../common/loader";
import DeleteModal from "../common/deleteModel";
import { ReactComponent as ThreeDotIC } from "../../assets/svg/three-dot-ic.svg";
import { useGlobal } from "../../GlobalContext";
import ProfileImageModal from "../common/common-preview";
export const ViewProduct = () => {
  const { rolePermissionList, userType } = useGlobal();
  const [activeTab, setActiveTab] = useState("Details");
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};
  const from = location.state?.from;
  const handleBack = () => {
    if (from === "vendor") {
      navigate("/viewVendor", {
        state: {
          activeTab: "product",
          id: location.state?.vendorId,
        },
      });
    } else {
      navigate("/product"); // product list
    }
  };
  const [statusListOption, setListStageOption] = useState([
    { value: true, label: "Active" },
    { value: false, label: "In-Active" },
  ]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const tabs = [
    "Details",
    // "Purchase Request",
    // "Purchase Quotation",
    // "Purchase Order",
  ];
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true,
    ) > -1
      ? true
      : false;
  }
  // api
  const [isLoading, setIsLoading] = useState(false);
  const [productDetails, setProductDetails] = useState({});

  const getProduct = async () => {
    setIsLoading(true);
    try {
      const response = await getProductDetailsApi(id);
      if (response.data.success === true) {
        const fetchedProduct = response.data.product;
        setProductDetails(fetchedProduct);

        console.log("Vendor details:", fetchedProduct);
      }
    } catch (err) {
      console.error("Error fetching vendor:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const updateStatus = async (id, value) => {
    setIsLoading(true);
    const bodyData = {
      status: value,
    };
    try {
      const response = await updateStatusApi(id, bodyData);
      console.log("response....1", response);
      if (response.success === true) {
        getProduct();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const deleteProduct = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteProductApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getProduct();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);

        handleBack();
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  // delete Api

  useEffect(() => {
    if (id != null) {
      getProduct();
    }
  }, [id]);
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  const openFile = (fileUrl = "") => {
    if (!fileUrl) return;

    const cleanUrl = fileUrl.split("?")[0].toLowerCase();

    // 🖼 Images → popup
    if (
      cleanUrl.endsWith(".png") ||
      cleanUrl.endsWith(".jpg") ||
      cleanUrl.endsWith(".jpeg") ||
      cleanUrl.endsWith(".gif") ||
      cleanUrl.endsWith(".webp")
    ) {
      setSelectedProfile(fileUrl);
      setShowProfilePopup(true);
      return;
    }

    // 📄 PDF → open directly in browser
    if (cleanUrl.endsWith(".pdf")) {
      setSelectedProfile(fileUrl);
      setShowProfilePopup(true);
      return;
    }

    // 📊 Office files → Office Viewer
    if (
      cleanUrl.endsWith(".xls") ||
      cleanUrl.endsWith(".xlsx") ||
      cleanUrl.endsWith(".doc") ||
      cleanUrl.endsWith(".docx") ||
      cleanUrl.endsWith(".ppt") ||
      cleanUrl.endsWith(".pptx")
    ) {
      const officeViewerUrl =
        "https://view.officeapps.live.com/op/view.aspx?src=" +
        encodeURIComponent(fileUrl);

      window.open(officeViewerUrl, "_blank", "noopener,noreferrer");
      return;
    }

    // ⬇ Default → download / open
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };
  return (
    <>
      <ProfileImageModal
        show={showProfilePopup}
        onClose={() => setShowProfilePopup(false)}
        imageUrl={selectedProfile}
      />{" "}
      <LoaderModal show={isLoading} />
      <DeleteModal
        title={"product"}
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteProduct}
      />
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Products" />
        {/* Main Content */}
        <div className="rounded-4 flex-grow-1">
          <div style={{ backgroundColor: "#F5F8FA" }}>
            <Navbar pageTitle="Products" />
            <div className="d-flex align-items-center p-3 bg-white justify-content-between">
              <div className="d-flex align-items-center gap-3">
                <div
                  onClick={() => {
                    handleBack();
                  }}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid #EBEBEB",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                >
                  <img
                    src={back}
                    alt="back"
                    style={{ maxWidth: "60%", maxHeight: "60%" }}
                  />
                </div>

                <div className="d-flex gap-3 align-items-center">
                  <img
                    src={
                      productDetails.image && productDetails.image.trim() !== ""
                        ? productDetails.image
                        : productDefault
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      openFile(
                        productDetails.image
                          ? productDetails.image
                          : productDefault,
                      );
                    }}
                    alt="Profile"
                    className="avatar-pro me-1 ms-0"
                  />
                  <div className="d-flex flex-column">
                    <p className="m-0 fs-16 fw-400">
                      {productDetails.name ?? "-"}
                    </p>
                    <p className="textGrey m-0 fs-12 fw-400">
                      Code :
                      <span className="textPurple fs-12 fw-500">
                        {" "}
                        {productDetails.code ?? "-"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="d-flex gap-2">
                <Dropdown>
                  <Dropdown.Toggle
                    variant="light"
                    id="dropdown-sort"
                    className={`d-flex align-items-center justify-content-between rounded-5 ${
                      productDetails.status === true
                        ? "backgroundGreenLt"
                        : "backgroundLightOrange"
                    }`}
                    style={{
                      padding: "6px 12px",
                    }}
                  >
                    <span className="d-flex align-items-center px-1 gap-2">
                      <span
                        className={
                          productDetails.status === true
                            ? "backgroundGreen"
                            : "backgroundYellow"
                        }
                        style={{
                          width: "10px",
                          height: "10px",
                          borderRadius: "3px",
                          display: "inline-block",
                        }}
                      ></span>

                      <span className="dropdown-text textcolor fs-13 fw-500">
                        {productDetails.status === true
                          ? "Active"
                          : "In-Active"}
                      </span>

                      <span className="dropdown-toggle-arrow">
                        <DownArrowIc />
                      </span>
                    </span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    style={{
                      backgroundColor: "white",
                      borderRadius: "8px",
                      border: "1px solid #EBEBEB",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {statusListOption.map((option) => (
                      <Dropdown.Item
                        className="fs-14 fw-500 textcolor"
                        key={option}
                        onClick={() => updateStatus(id, option.value)}
                        // active={selected === option}
                      >
                        {option.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>

                <div onClick={(e) => e.stopPropagation()}>
                  {(checkPermission("Products", "edit_permission") ||
                    checkPermission("Products", "delete_permission")) && (
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between rounded-5 bg-white"
                        style={{
                          width: "36px",
                          height: "36px",
                          border: "1px solid #EBEBEB",
                        }}
                      >
                        <span className="d-flex align-items-center px-1 gap-2">
                          <ThreeDotIC />
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {checkPermission("Products", "edit_permission") && (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate("/product/create", {
                                state: { id: id },
                              });
                            }}
                          >
                            Edit
                          </Dropdown.Item>
                        )}

                        {checkPermission("Products", "delete_permission") && (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeleteId(id);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex gap-3 p-3">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`px-4 py-2 rounded-pill fw-semibold border-0 ${
                    activeTab === tab
                      ? "text-white fs-13 fw-600"
                      : "text-dark border border-1 border-light fs-13 fw-500"
                  }`}
                  style={{
                    backgroundColor: activeTab === tab ? "#4F46E5" : "#fff",
                    boxShadow:
                      activeTab === tab ? "0 2px 6px rgba(0,0,0,0.1)" : "none",
                  }}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="px-3 rounded">
              {activeTab === "Details" && (
                <div className="row">
                  <div className="col-6">
                    <div className="bg-white p-3 h-100">
                      <p className="fs-16 fw-600">Product Details</p>
                      <div className="row">
                        <div className="col-3 my-2 textGrey fs-14 fw-400">
                          Product Group
                        </div>
                        <div className="col-9 my-2 fs-14 fw-500">
                          {productDetails.product_group ?? "-"}
                        </div>
                        <div className="col-3 my-2 textGrey fs-14 fw-400">
                          UOM
                        </div>
                        <div className="col-9 my-2 fs-14 fw-500">
                          {productDetails.uom ?? "-"}{" "}
                        </div>
                        <div className="col-3 my-2 textGrey fs-14 fw-400">
                          Origin
                        </div>
                        <div className="col-9 my-2 fs-14 fw-500 d-flex align-items-center gap-2">
                          {/* <img src={india} alt="indida" /> */}
                          {productDetails.origion ?? "-"}
                        </div>
                        {/* <div className="col-3 my-2 textGrey fs-14 fw-400">
                          Inspection Type
                        </div>
                        <div className="col-9 my-2 fs-14 fw-500">
                          Manual Testing
                        </div>
                        <div className="col-3 my-2 textGrey fs-14 fw-400">
                          Min. Qty
                        </div>
                        <div className="col-9 my-2 fs-14 fw-500">300</div> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="bg-white p-3">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <p className="fs-16 fw-600 m-0">Product dimension</p>
                        <div
                          className="text-black border-0 px-3 py-1 rounded-3"
                          style={{ backgroundColor: "#F8F8F8" }}
                        >
                          {productDetails.dimension ?? "-"}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-3 my-2 textGrey fs-14 fw-400">
                          Length
                        </div>
                        <div className="col-9 my-2 fs-14 fw-500">
                          {productDetails.length ?? "-"}
                        </div>
                        <div className="col-3 my-2 textGrey fs-14 fw-400">
                          Breadth
                        </div>
                        <div className="col-9 my-2 fs-14 fw-500">
                          {productDetails.width ?? "-"}{" "}
                        </div>
                        <div className="col-3 my-2 textGrey fs-14 fw-400">
                          Height
                        </div>
                        <div className="col-9 my-2 fs-14 fw-500">
                          {productDetails.height ?? "-"}
                        </div>
                        {/* <div className="col-12 mt-4">
                          <p
                            className="fs-13 fw-300 d-flex align-items-center gap-2 px-3 py-2 rounded-4"
                            style={{ backgroundColor: "#EEEDFF" }}
                          >
                            <img src={iButton} alt="i" /> You can change
                            measurement type using above drop down.
                          </p>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mt-3">
                    <div className="bg-white p-3">
                      <p className="fs-16 fw-600">
                        Suppliers - {productDetails?.suppliers?.length ?? "0"}
                      </p>
                      <div className="row g-3">
                        {" "}
                        {/* g-3 adds gap between both columns and rows */}
                        {productDetails?.suppliers?.length > 0 ? (
                          productDetails.suppliers.map((supplier, index) => (
                            <div
                              className="col-12 col-md-6 col-lg-4"
                              key={supplier.value || index}
                            >
                              <div
                                className="d-flex gap-3 p-2 rounded-4"
                                style={{
                                  backgroundColor:
                                    index === 0
                                      ? "#FFEFF0"
                                      : index === 1
                                        ? "#FFF5EB"
                                        : "#E9F8FF",
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  src={
                                    supplier.image &&
                                    supplier.image.trim() !== ""
                                      ? supplier.image
                                      : profileIc
                                  }
                                  alt={supplier.label}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openFile(
                                      supplier.image &&
                                        supplier.image.trim() !== ""
                                        ? supplier.image
                                        : profileIc,
                                    );
                                  }}
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    objectFit: "cover",
                                  }}
                                />
                                <div className="d-flex flex-column justify-content-center">
                                  <p className="fs-16 fw-400 m-0">
                                    {supplier.label ?? "-"}
                                  </p>
                                  <div className="d-flex gap-2 align-items-center">
                                    <img src={locationIc} alt="location" />
                                    <p className="m-0 fs-12 fw-400 textGrey">
                                      {supplier.city ?? "-"}
                                    </p>
                                    <div
                                      className="rounded-circle"
                                      style={{
                                        backgroundColor: "#D9D9D9",
                                        width: "4px",
                                        height: "4px",
                                      }}
                                    ></div>
                                    <p
                                      className="m-0 textBlue bg-white px-3 py-1 fs-11 fw-500 rounded-pill"
                                      style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: "150px",
                                      }}
                                    >
                                      {supplier.industry ?? "-"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p className="text-muted text-center mt-3">
                            No suppliers found
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mt-3">
                    <div className="bg-white p-3">
                      <p className="fs-16 fw-600">Description</p>
                      <p className="fs-14 fw-400">
                        {productDetails.description ?? "-"}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
